export enum AppRoutes {
  NotFound = '/notfound',
}
export const DiscoverWebTitle: string = 'Sky discover';
